<template>
     <div class="c-o-section-cards">
        <div class="o-grid o-grid--25-25-25-25">
            <div class="o-grid__block" v-for="(item, index) in content.linked_posts" :key="index">
                <card :card="item" :horizontalLayout="false"></card>
            </div>
        </div>
    </div>
</template>
<script>
    import Card from '../../molecules/MoleculeCardLink.vue';
    import filters from '../../../../filters/index.js';

    export default {
        filters: filters,
        props:['content', 'data'],
        components: {
            Card
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionCards.vue